// i18n area 'system' — locale fr-FR (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/system.fr-FR.meta.json.
import type { enUS } from './system'

export const frFR: typeof enUS = {
  diagnostics: {
    title: 'Diagnostic',
    subtitle: "Ce qui ne va pas, le pire d'abord — la même lentille que tvirt diagnose",
    reload: 'Recharger',
    loadError: "Le diagnostic n'a pas pu être lu",
    exportBundle: 'Exporter le bundle',
    exportError: "Le bundle n'a pas pu être créé",
    noProblem: 'Aucun problème dans les zones inspectées',
    nothingInspected: "RIEN n'a été inspecté — ce n'est pas un certificat de bonne santé",
    inspected: 'Inspectées',
    notInspected: 'NON inspectées',
    localHint: "Les zones locales du nœud (unités systemd, journal) ne se lisent que depuis la CLI : tvirt diagnose --area local — la voie quand l'API ne répond pas.",
    thresholds: 'tâches échouées sous {hours} h, heartbeat en retard au-delà de {seconds} s',
    severity: {
      critical: 'Critique',
      warning: 'Avertissement',
      unknown: 'Inconnu'
    }
  },
  explorer: {
    title: 'Explorateur de ressources',
    root: 'Racine',
    empty: 'Aucune ressource dans ce scope',
    previewHint: "Sélectionnez un objet pour en voir l'aperçu",
    open: 'Ouvrir',
    openScoped: 'Ouvrir la liste dans ce scope',
    kinds: {
      vm: 'VM',
      vmTemplate: 'Template VM',
      ct: 'CT',
      ctTemplate: 'Template CT',
      app: 'App',
      overlayNetwork: 'Réseau overlay',
      networkService: 'Service réseau',
      fabric: 'Fabric',
      subnet: 'Subnet',
      storage: 'Pool de storage',
      disk: 'Disque',
      catalogFile: 'Fichier de catalogue',
      ociRegistry: 'Registre OCI',
      ociImage: 'Image OCI',
      cephCluster: 'Cluster Ceph',
      backupDestination: 'Destination de backup',
      user: 'Utilisateur',
      group: 'Groupe',
      role: 'Rôle',
      credential: 'Identifiant',
      tag: 'Tag',
      proximityRule: 'Règle de proximité'
    }
  },
  tags: {
    title: 'Tags',
    empty: 'Aucun tag',
    add: 'Ajouter un tag',
    remove: 'Retirer',
    name: 'Tag',
    value: 'Valeur',
    save: 'Enregistrer',
    saveError: "Impossible d'enregistrer les tags",
    loadError: 'Impossible de charger le vocabulaire des tags',
    noVocabulary: 'Aucun tag disponible pour ce type de ressource',
    overwrite: 'Remplacer la valeur actuelle',
    createTitle: 'Créer un tag',
    editTitle: 'Modifier le tag',
    nameHint: 'Lettres, chiffres, points, tirets et underscores — pas de ":" ni de "/" ; le préfixe tvirt- est réservé à la plateforme',
    cardinality: 'Cardinalité',
    cardinalitySingle: 'Une seule valeur',
    cardinalityMultiple: 'Plusieurs valeurs',
    cardinalityHint: 'Avec une seule valeur, réassigner le tag demande de la remplacer',
    autoCreate: 'Auto-création des valeurs',
    autoCreateOn: "À l'assignation",
    autoCreateOff: 'Déclarées seulement',
    autoCreateHint: 'Activée : assigner une valeur nouvelle la crée. Désactivée : seules les valeurs déclarées peuvent être assignées',
    values: 'Valeurs',
    noValues: 'Aucune valeur déclarée',
    addValue: 'Ajouter une valeur',
    duplicateValue: 'Valeur en double',
    kinds: 'Types de ressource',
    kindsAll: 'Tous',
    kindsPlaceholder: 'Tous',
    kindsHint: 'Laissez vide pour admettre chaque type de ressource taggable',
    systemChip: 'Système',
    deleteCascade: 'Supprimer aussi les affectations',
    deleteCascadeHint: 'Un tag encore affecté à une ressource est refusé : avec cette option, les valeurs et toutes les affectations disparaissent avec le tag.'
  },
  scopes: {
    title: 'Scopes',
    createTitle: 'Créer un scope',
    editTitle: 'Renommer le scope',
    path: 'Chemin',
    segment: 'Segment',
    segmentHint: 'Minuscules, chiffres et tirets (DNS-1123)',
    parent: 'Parent',
    rootChip: 'Racine',
    preview: 'Nouveau scope',
    pickLabel: 'Scope',
    pickHint: "Où vit l'objet dans l'arbre du cluster — la racine ou un vDC à l'intérieur.",
    ociCache: 'Cache OCI (override)',
    appEphemeral: 'Pool éphémère App (override)',
    inherit: 'Hériter',
    inheritsFrom: 'Hérite de',
    inheritsCluster: 'Hérite du défaut du cluster',
    inheritsNone: 'Hérite — aucun pool effectif',
    failoverProtection: 'Protection en mode dégradé',
    networkWeight: 'Poids réseau',
    networkCeil: 'Plafond réseau (Mbps)',
    protectionProtected: 'Protégée',
    protectionExpendable: 'Sacrifiable en mode dégradé',
    protectionDefault: 'Défaut du cluster'
  },
  sysinfo: {
    summary: 'Versions de la plateforme dans le cluster, composants de chaque nœud, manuel d\'administration et licence.',
    platformTitle: 'Plateforme TVirt',
    platformSubtitle: 'Versions observées sur les nœuds du cluster',
    versionOnNodes: '{version} sur {n} nœuds',
    versionOnOneNode: '{version} sur 1 nœud',
    mixedVersions: "Plus d'une version de la plateforme dans le cluster — attendu seulement pendant une mise à jour en cours (au plus deux).",
    tooManyVersions: 'Plus de deux versions de la plateforme dans le cluster — jamais attendu, même pendant une mise à jour : vérifiez les nœuds ci-dessous.',
    unreportedNodes: 'Encore aucun rapport de versions de : {nodes}',
    noVersionsYet: "Aucun nœud n'a encore rapporté ses versions.",
    nodesUnavailable: "La liste des nœuds n'est pas visible avec vos permissions — impossible d'afficher les versions de la plateforme.",
    colNode: 'Nœud',
    manualTitle: 'Manuel d\'administration',
    manualSubtitle: 'Copie locale, servie par ce cluster',
    manualBody: 'Le manuel TVirt complet en PDF, servi directement par la plateforme — disponible aussi dans les environnements air-gapped.',
    manualLink: 'Manuel d\'administration (PDF)',
    apiExplorerTitle: 'Explorateur d\'API',
    apiExplorerSubtitle: 'Le contrat OpenAPI, navigable',
    apiExplorerBody: 'Le contrat OpenAPI complet de la plateforme — chaque route, schéma et code de réponse — explorable depuis le navigateur, servi à travers ce nœud.',
    apiExplorerLink: 'Explorer l\'API',
    kubeTitle: 'Compatibilité Kubernetes',
    kubeSubtitle: 'kubectl et ses outils, devant l\'API native',
    kubeBody: 'TVirt KubeCompat projette les Pods, Deployments, Services, namespaces, nœuds et événements dans le dialecte Kubernetes — en lecture seule, plus la suppression des Deployments. Chaque appel passe par l\'API native avec vos permissions : dans le kubeconfig, utilisez un app token comme bearer.',
    kubeEndpoint: 'Endpoint pour kubectl',
    kubeStatusActive: 'Actif — Kubernetes {version}',
    kubeStatusMissing: 'Non installé sur ce nœud (paquet trantor-tvirt-kubecompat)',
    kubeStatusDown: 'Installé mais ne répond pas — vérifiez l\'unité trantor-tvirt-kubecompat',
    kubeStatusChecking: 'Vérification en cours…'
  },
  licensing: {
    title: 'Licence du cluster',
    subtitle: 'Licence par abonnement — au plus une par cluster',
    absentTitle: 'Aucune licence enregistrée',
    absentBody: 'Sans licence valide, le cluster refuse de démarrer de nouvelles machines virtuelles (les VM allumées restent allumées). Enregistrez le product key reçu avec votre abonnement.',
    registerButton: 'Enregistrer la licence',
    removeButton: 'Retirer la licence',
    state: {
      ok: 'Valide',
      limitExceeded: 'Limite dépassée',
      expired: 'Expirée'
    },
    productKeyLabel: 'Product key',
    basisLabel: 'Base de la limite',
    basis: {
      concurrentVms: 'VM allumées simultanées',
      physicalCores: 'Cœurs physiques (total du cluster)'
    },
    limitLabel: 'Limite',
    usageLabel: 'Usage actuel',
    usageOf: '{used} sur {limit}',
    usagePartial: 'somme partielle — {n} nœud(s) sans topologie CPU observée',
    usageUnknown: 'pas observable pour le moment',
    expiresLabel: 'Expiration',
    neverExpires: 'jamais',
    registeredLabel: 'Enregistrée',
    gateNote: 'Avec une licence absente, expirée ou au-delà de sa limite, le cluster refuse de démarrer de NOUVELLES machines virtuelles. Les VM allumées restent allumées et les redémarrages HA ne sont pas affectés.',
    devStage: "Phase de développement : le product key est accepté tel quel avec les limites déclarées ici ; la validation par clé signée arrivera dans une release future.",
    dialogTitle: 'Enregistrer la licence',
    dialogExpiresHelp: "Vide = la licence n'expire jamais",
    dialogSubmit: 'Enregistrer',
    dialogError: "Impossible d'enregistrer la licence.",
    removeTitle: 'Retirer la licence',
    removeBody: "Le cluster restera SANS LICENCE : les nouvelles machines virtuelles refuseront de démarrer tant que vous n'en enregistrez pas une. Les VM allumées restent allumées.",
    removeConfirm: 'Retirer',
    removeError: 'Impossible de retirer la licence.'
  },
  rbac: {
    tabRoles: 'Rôles',
    tabGrants: 'Délégations',
    rolesTitle: 'Rôles',
    createRoleTitle: 'Créer un rôle',
    editRoleTitle: 'Modifier le rôle',
    nameHint: 'Minuscules, chiffres et tirets ; le préfixe tvirt- est réservé',
    systemChip: 'Système',
    permissions: 'Permissions',
    permissionsPlaceholder: 'Ajouter une permission…',
    includedRoles: 'Rôles inclus',
    includedRolesPlaceholder: 'Ajouter un rôle…',
    grantsTitle: 'Délégations',
    createGrantTitle: 'Créer une délégation',
    principal: 'Principal',
    principalKind: 'Type de principal',
    principalUser: 'Utilisateur',
    principalGroup: 'Groupe',
    role: 'Rôle',
    grantRight: 'Délégation',
    grantRightChip: 'Peut déléguer',
    grantRightLabel: 'Avec droit de délégation (le destinataire peut à son tour déléguer ce rôle)',
    effective: 'Effective',
    notEffective: 'Non effective',
    createdAt: 'Créée',
    scopeHint: "/path exact, /path/* récursif — les délégations s'ancrent à une racine montée (/* n'est pas délégable)"
  },
  groups: {
    title: 'Groupes',
    createTitle: 'Créer un groupe',
    nameHint: 'Minuscules, chiffres et tirets ; unique dans le scope',
    members: 'Membres',
    membersTitle: 'Membres',
    membersPlaceholder: 'Ajouter un utilisateur…',
    noMembers: 'Aucun membre',
    realmMappings: 'Mappages realm',
    realmMappingsTitle: 'Mappages realm',
    realmMappingsHint: "À quoi correspond ce groupe dans chaque realm externe. L'appartenance se lit depuis la directory au moment de la connexion : un groupe de directory que personne ne mappe ici est ignoré, et l'imbrication n'est pas résolue — aplatissez-la côté directory.",
    realm: 'Realm',
    externalGroup: 'Groupe externe',
    addRealmMapping: 'Ajouter un mappage',
    removeRealmMapping: 'Retirer le mappage',
    noRealmMappings: 'Aucun mappage realm',
    sectionGeneral: 'Général',
    mappingsNoRealms: "Aucun realm externe configuré — la surface de mappage se débloque dès qu'un realm existe.",
    mappingsNoRealmsLink: 'Ouvrir le tab Realms et SSO',

    // L'obligation MFA imposée par le groupe (round #178 moitié B) : OR pur —
    // un groupe ne peut qu'AJOUTER l'obligation, jamais la retirer.
    mfaRequired: 'Obligation MFA',
    mfaRequiredChip: 'Impose la MFA',
    mfaNotRequiredChip: 'Aucune obligation',
    mfaRequiredHint:
      "OR pur : un groupe peut AJOUTER l'obligation du second facteur à ses membres — aux identités externes aussi, via les mappages realm — jamais la retirer. Elle vaut à partir de la prochaine connexion : les sessions ouvertes ne sont pas fermées."
  },
  users: {
    title: 'Utilisateurs',
    createTitle: 'Créer un utilisateur',
    editTitle: "Modifier l'utilisateur",
    username: "Nom d'utilisateur",
    usernameHint: 'Minuscules, chiffres, points et tirets',
    displayName: 'Nom affiché',
    enabled: 'Activé',
    state: 'État',
    enabledChip: 'Activé',
    disabledChip: 'Désactivé',
    lockedChip: 'Verrouillé',
    password: 'Mot de passe',
    passwordSetChip: 'Défini',
    mustChangeChip: 'À changer',
    initialPassword: 'Mot de passe initial',
    initialPasswordHint: "L'utilisateur devra le changer à la première connexion",
    lastLogin: 'Dernière connexion',
    neverLoggedIn: 'Jamais connecté',
    setPasswordTitle: 'Définir le mot de passe',
    setPasswordHint: "Remplacement administratif — il exige votre mot de passe (mode sudo) et oblige l'utilisateur à le changer à la prochaine connexion.",
    operatorPassword: 'Votre mot de passe',
    unlock: 'Déverrouiller le compte',
    revokeTitle: 'Révoquer les sessions',
    revokeBody: 'Toutes les sessions actives de cet utilisateur sont terminées immédiatement.',
    revokeIncludeTokens: 'Révoquer aussi les app tokens',
    revokeConfirm: 'Révoquer',
    tabAccount: 'Compte',
    tabSecurity: 'Sécurité',
    usernameImmutableHint: "Le nom d'utilisateur est l'identité du compte — fixé à la création",
    groups: 'Groupes',
    noGroups: 'Aucun groupe',
    mustChangePassword: 'Changement de mot de passe requis',
    failedAttempts: 'Tentatives de connexion échouées',
    lockedUntil: "Verrouillé jusqu'à",
    tabUsers: 'Utilisateurs',
    tabGroups: 'Groupes',
    tabRealms: 'Realms et SSO',
    tabMfa: 'MFA',
    mfa: {
      title: 'Second facteur (MFA)',
      methodsTitle: 'Méthodes disponibles',
      methodsSubtitle: 'Ce que cette installation sait vérifier comme second facteur',
      methodsError: 'Impossible de charger le registre des méthodes',
      builtinChip: 'Intégré',
      enrollableChip: 'Enrollment dans TVirt',
      delegatedChip: 'Géré en externe',
      state: 'État',
      stateActive: 'Actif',
      statePending: "En attente d'enrollment",
      stateNone: 'Non enrôlé',
      required: 'Obligation MFA',
      requiredChip: 'Obligatoire',
      notRequiredChip: 'Non obligatoire',
      enrolledAt: 'Enrollment du',
      enrolledMethods: 'Méthodes enrôlées',
      noMethods: "Pas d'enrollment",
      codesRemaining: 'Codes de récupération restants',
      resetTitle: 'Réinitialiser le second facteur',
      resetHint:
        "L'enrollment et tous les codes de récupération sont effacés : à la prochaine connexion, l'utilisateur refera l'enrollment depuis zéro. L'obligation MFA reste telle quelle — un administrateur ne définit jamais un secret, il ne fait que l'effacer.",
      resetConfirm: 'Réinitialiser',
      resetError: 'Impossible de réinitialiser le second facteur',
      empty: "Encore aucun utilisateur géré — les comptes apparaissent ici dès qu'ils existent, chacun avec son état du second facteur.",

      // Moitié B (round #178) : provenance du verdict effectif, enrollments
      // externes avec l'état orphelin, groupes qui imposent l'obligation.
      viaSelf: 'Personnelle',
      viaSelfHint: 'La contribution personnelle du compte (son flag) — la seule partie que le crayon modifie.',
      viaGroupHint: "Obligation héritée de ce groupe : retirer le flag personnel ne libère pas l'utilisateur — on intervient sur le groupe, dans le tab Groupes.",
      subject: 'Identité',
      lastSeenAt: 'Dernière confirmation',
      enrollmentPending: 'En suspens',
      orphanChip: 'Orphelin',
      orphanDirectoryMiss: "L'identité n'est plus dans la directory",
      orphanRealmRemoved: 'Le realm a été retiré de TVirt',
      orphanedAt: 'Orphelin depuis',
      directoryUuid: 'UUID dans la directory',
      externalTitle: 'Enrollments externes',
      externalEmpty: "Encore aucun enrollment externe — il naît à la première connexion d'une identité de directory soumise à l'obligation MFA.",
      orphanHelp:
        "Un enrollment orphelin ne s'efface jamais tout seul : c'est du matériel de sécurité — il reste pour l'audit et, si l'identité réapparaît dans la directory, elle retrouve son facteur. La seule sortie est la réinitialisation administrative.",
      visibilityHint: "Les enrollments externes résident à la racine du cluster : seul les voit qui détient user.read sur l'arbre entier.",
      orphanResetHint:
        "La ligne orpheline est supprimée définitivement : plus personne ne la réclame. Si l'identité réapparaît dans la directory, elle refera l'enrollment depuis zéro.",
      enforcingTitle: 'Groupes qui imposent la MFA',
      enforcingSubtitle:
        "L'ancre de l'obligation pour les identités externes est le groupe : ses mappages realm disent quelle population de directory elle atteint. L'enrollment externe naît à la première connexion de l'utilisateur obligé.",
      enforcingEmpty: "Aucun groupe n'impose la MFA — l'obligation s'active sur le groupe, depuis le tab Groupes.",
      enforcingError: 'Impossible de charger les groupes qui imposent la MFA'
    }
  },
  realms: {
    title: "Realms d'authentification",
    createTitle: 'Créer un realm',
    editTitle: 'Modifier le realm',
    name: 'Realm',
    nameHint: 'Le domaine que les utilisateurs saisissent après le @ (example.com) — immuable après la création',
    nameImmutableHint: "Le nom du realm est estampillé dans chaque session et chaque ligne d'audit qui l'a jamais nommé — le renommer réécrirait l'histoire",
    kind: 'Type',
    kindLdap: 'LDAP / Active Directory',
    kindHint: "OIDC et SAML arrivent avec les prochains rounds — aujourd'hui un realm est une directory LDAPv3",
    kindCategory: 'Type de realm',
    kindSelectHint: 'Sélectionnez le type de directory sur lequel ce realm authentifiera.',
    kindCard: {
      ldap: {
        name: 'LDAP / Active Directory',
        desc: 'Username et mot de passe vérifiés avec un bind sur une directory LDAPv3 — Active Directory, FreeIPA, OpenLDAP.'
      },
      oidc: {
        name: 'OpenID Connect',
        desc: 'Single sign-on depuis le navigateur, délégué à un identity provider OpenID Connect — arrive avec les prochains rounds.'
      },
      saml: {
        name: 'SAML 2.0',
        desc: "Single sign-on d'entreprise avec des assertions SAML 2.0 — arrive avec les prochains rounds."
      }
    },
    tabBind: 'Bind',
    enabled: 'Activé',
    urls: 'Serveurs de la directory',
    urlsHint: "Un URL ldap:// ou ldaps:// par ligne (1–8), essayés dans l'ordre — failover, jamais d'équilibrage",
    startTls: 'StartTLS',
    verifyCertificate: 'Vérifier le certificat',
    cleartextWarning: 'Sans ldaps:// ni StartTLS, le mot de passe de bind traverse le réseau en clair — acceptable en laboratoire, jamais en production.',
    noVerifyWarning: "Une session TLS non vérifiée n'authentifie personne : désactivez la vérification seulement face à une directory que vous ne pouvez pas corriger.",
    caCertificate: 'Certificat CA (PEM)',
    caCertificateHint: 'Bundle CA optionnel épinglé pour le handshake TLS/StartTLS de ce realm ; vide le retire',
    caCertificatePinned: 'Épinglé',
    connectTimeout: 'Timeout (secondes)',
    connectTimeoutHint: "Échéance par URL de connexion et de requête (1–60) ; à l'expiration, l'URL suivant est essayé",
    bindDn: 'Bind DN',
    bindDnHint: "Le service account qui exécute la recherche de l'utilisateur ; vide = search bind anonyme (refusé par AD)",
    anonymousBind: 'Search bind anonyme',
    bindCredential: 'Mot de passe de bind (keystore)',
    bindCredentialHint: 'Une entrée usernamePassword du keystore avec le mot de passe de bind — le secret ne vit jamais sur le realm',
    bindCredentialNone: 'Aucun (bind anonyme)',
    bindCredentialEmpty: 'Aucune entrée usernamePassword dans le keystore — créez-en une sous Système > Identifiants pour le mot de passe de bind.',
    baseDn: 'Base DN',
    baseDnHint: "Le sous-arbre d'où part la recherche de l'utilisateur (DC=example,DC=com)",
    userFilter: 'Filtre utilisateur',
    userFilterHint: '%u est remplacé par la partie locale du login, avec échappement RFC 4515 ; les directories non-AD veulent typiquement (&(objectClass=inetOrgPerson)(uid=%u))',
    memberOfAttribute: 'Attribut memberOf',
    memberOfAttributeHint: "Lu une seule fois, au login — les groupes non mappés sont ignorés, l'imbrication n'est pas résolue",
    uuidAttribute: 'Attribut UUID',
    uuidAttributeHint: "L'UUID immuable dans le realm (objectGUID sur AD, entryUUID sur OpenLDAP) — estampillé dans l'audit à côté de utilisateur@realm",
    displayNameAttribute: 'Attribut du nom affiché',
    displayNameAttributeHint: "Utilisé pour saluer l'utilisateur ; à défaut, le nom de login est utilisé",
    sudoHint: "Les écritures sur les realms sont protégées par sudo : un realm est une porte d'entrée dans la plateforme",
    deleteBody: "Les mappages de groupes du realm partent avec lui ; les sessions qu'il a authentifiées restent vivantes jusqu'à leur expiration — un realm supprimé n'admet simplement plus personne.",
    tabConnection: 'Connexion',
    tabDirectory: 'Directory',
    testTitle: 'Tester la connexion',
    testHint: 'Une sonde de configuration, jamais une authentification : elle se connecte, fait le bind avec le service account et — avec un username — exécute le filtre utilisateur.',
    testUsername: "Nom d'utilisateur (optionnel)",
    testUsernameHint: 'Une partie locale sur laquelle exécuter le filtre utilisateur — 1 correspondance est la réponse saine',
    testRun: 'Lancer le test',
    testError: "Impossible d'exécuter la sonde",
    testReachable: 'Directory joignable, bind de service accepté',
    testUnreachable: 'Directory NON joignable',
    matchedOne: 'Le filtre utilisateur a trouvé exactement 1 entrée — la réponse saine.',
    matchedNone: "Le filtre utilisateur n'a trouvé aucune entrée : le filtre ou le base DN est erroné.",
    matchedMany: "Le filtre utilisateur a trouvé {count} entrées : il n'est pas sélectif, et les connexions seraient ambiguës (refusées).",
    mappingsPointer: 'À quoi correspond un groupe externe est une propriété du groupe TVirt (ses mappages realm) : le point de vérité vit dans le tab Groupes.',
    mappingsPointerLink: 'Ouvrir le tab Groupes',
    rootHomeHint: 'Les identités d\'un realm externe vivent à la racine du cluster, jamais dans un vDC : les permissions s\'attribuent là où il le faut, par délégations — sur le groupe ou directement sur l\'utilisateur, exactement comme pour les natifs.'
  },
  credentials: {
    title: 'Identifiants',
    createTitle: 'Créer un identifiant',
    editTitle: "Modifier l'identifiant",
    kind: 'Type',
    kindUsernamePassword: 'Username et mot de passe',
    kindIscsiChap: 'CHAP (iSCSI)',
    kindNvmeDhchap: 'DH-HMAC-CHAP (NVMe)',
    kindCephx: 'cephx (identité Ceph)',
    kindHintUsernamePassword: 'Immuable. Pour les storages CIFS/SMB — le compte de mount dont le worker utilise le secret au moment du mount.',
    kindHintIscsiChap: "Immuable. Pour l'authentification CHAP iSCSI — username = nom CHAP, secret = secret CHAP.",
    kindHintNvmeDhchap: "Immuable. Pour le DH-HMAC-CHAP de NVMe over Fabrics — secret = le blob DHHC-1:xx:… ; le username n'est qu'une étiquette.",
    kindHintCephx: 'Immuable. Pour les clients Ceph — username = nom du client (client.…), secret = la clé base64.',
    kindImmutableHint: 'Le type est immuable après la création — en changer signifie un nouvel identifiant.',
    username: "Nom d'utilisateur",
    usernameChap: 'Nom CHAP',
    usernameNvme: 'Étiquette',
    usernameCephx: 'Nom du client',
    usernameHint: 'Compte optionnel auquel appartient le secret',
    usernameHintChap: "Le nom CHAP avec lequel l'initiator s'authentifie",
    usernameHintNvme: 'Non utilisée par le transport — une étiquette libre pour vos notes',
    usernameHintCephx: 'Le nom du client cephx — le préfixe client. est toléré',
    secret: 'Secret',
    secretHint: 'Écriture seule : utilisé par les consommateurs, jamais plus affiché.',
    secretHintNvmeDhchap: 'Écriture seule : le secret DH-HMAC-CHAP host dans sa forme canonique DHHC-1:xx:… — utilisé par les consommateurs, jamais plus affiché.',
    secretHintCephx: 'Écriture seule : la clé cephx base64 — utilisée par les consommateurs, jamais plus affichée.',
    secretEditHint: 'Laissez vide pour ne pas changer le secret — le renseigner effectue sa rotation.',
    createdAt: 'Créé',
    inUseError: "'{name}' est référencé par la configuration d'un storage — détachez-le d'abord là-bas.",
    nameHint: 'Minuscules, chiffres et tirets (DNS-1123) ; unique par scope',
    rotateTitle: 'Rotation du secret',
    rotateHint: 'Écriture seule : le nouveau secret remplace celui stocké — les consommateurs le prendront à leur prochain mount.',
    tabSecrets: 'Secrets',
    tabCertificates: 'Certificats',
    tabAuthorities: 'Autorités de certification',
    certificatesTitle: 'Certificats',
    authoritiesTitle: 'Autorités de certification',
    caCreateTitle: 'Nouvelle CA',
    certCreateTitle: 'Nouveau certificat',
    caMode: 'Origine',
    caModeGenerate: 'Générer avec TVirt',
    caModeImport: 'Importer (clé + certificat)',
    certMode: 'Origine',
    certModeIssue: 'Émettre depuis une CA du keystore',
    certModeImport: 'Importer (clé + certificat)',
    issuingCa: 'CA émettrice',
    issuingCaHint: 'Le certificat naît dans le scope de la CA, avec le parent enregistré',
    noCasHint: "Aucune CA dans le keystore — générez-en ou importez-en une d'abord dans le tab CA",
    commonName: 'Common name (CN)',
    commonNameCaHint: 'Le subject de la CA : lettres, chiffres, espace, point, underscore, tiret',
    commonNameCertHint: 'OpenVPN identifie les clients par le CN — gardez-le unique par CA',
    days: 'Validité (jours)',
    daysCaHint: '1–7300 jours ; 3650 (10 ans) est le défaut',
    daysCertHint: '1–3650 jours ; 365 est le défaut',
    keyType: 'Type de clé',
    keyTypeHint: 'EC P-256 est le défaut ; RSA pour les consommateurs legacy',
    usage: 'Usage',
    usageClient: 'Client (clientAuth)',
    usageServer: 'Serveur (serverAuth)',
    usageHint: "L'extended key usage pour lequel le certificat est émis",
    san: 'Noms alternatifs (SAN)',
    sanHint: 'Séparés par des virgules ; les IP littérales deviennent des entrées IP:, le reste DNS:',
    keyPem: 'Clé privée (PEM)',
    keyPemHint: 'Écriture seule : gardée dans le keystore, jamais plus affichée',
    certPem: 'Certificat (PEM)',
    certPemHint: "Le certificat public qui s'apparie à la clé",
    certPemCaHint: "Le certificat CA qui s'apparie à la clé (basicConstraints CA)",
    subject: 'Subject',
    issuer: 'Émetteur',
    parentCa: 'CA émettrice',
    parentCaImported: 'Importé — émis hors de TVirt',
    serial: 'Numéro de série',
    fingerprint: 'Fingerprint (SHA-256)',
    validFrom: 'Valide à partir du',
    validUntil: "Valide jusqu'au",
    expiry: 'Expiration',
    expired: 'Expiré',
    expiresInDays: 'Expire dans {days} j',
    revoked: 'Révoqué',
    revokedAtLabel: 'Révoqué le',
    revokeTitle: 'Révoquer le certificat',
    revokeAction: 'Révoquer',
    revokeWarning: "La révocation est définitive : le numéro de série entre dans la CRL de la CA émettrice et chaque consommateur qui refuse les certificats révoqués (OpenVPN en premier) rejettera celui-ci. Il n'existe pas d'un-revoke.",
    exportPem: 'Exporter le PEM',
    exportChain: 'Exporter le bundle de chaîne',
    exportCrl: 'Exporter la CRL',
    materialImmutableHint: 'Le matériel X.509 est immuable — réémettez ou réimportez',
    caInUseError: "'{name}' a encore des certificats émis vivants (ou un storage la référence) — révoquez-les ou supprimez-les d'abord."
  },
  proximity: {
    title: 'TVirt Proximity',
    subtitle: 'Placement, disponibilité et affinité — où tournent les VM du cluster et si elles doivent être allumées',
    loadError: "Le panneau Proximity a besoin du store de cluster — l'état de la flotte n'est pas joignable pour le moment",
    config: {
      title: 'Configuration',
      subtitle: "Politique de placement à l'échelle du cluster",
      save: 'Enregistrer',
      saveError: 'La configuration a été refusée',
      strategy: 'Stratégie de sélection',
      strategy_leastUsedResources: 'Moins de ressources utilisées',
      strategy_leastVms: 'Moins de VM',
      strategy_random: 'Aléatoire',
      strategyLeastUsedResourcesHint: "Parmi les candidats valides, le nœud avec le plus de RAM utilisable restante (total observé − réserve host − VM allumées), l'engagement vCPU comme départage. Déterministe à données égales.",
      strategyLeastVmsHint: 'Parmi les candidats valides, le nœud avec le moins de VM allumées ; les égalités se résolvent par nom. Déterministe à données égales.',
      strategyRandomHint: 'Uniformément aléatoire parmi les candidats valides.',
      liveness: 'Seuil de vitalité des nœuds (secondes)',
      livenessHint: 'Un membre silencieux au-delà du seuil est injoignable : exclu du placement et — sauf en maintenance — considéré comme mort par le decider HA, qui le clôture et redémarre ailleurs ses VM HA.',
      decider: 'Decider HA',
      deciderNone: 'pas encore élu'
    },
    nodesTitle: 'Nœuds',
    nodesSubtitle: 'Vitalité et capacité empirique — RAM utilisable = totale − base − engagée',
    nodeCol: 'Nœud',
    stateCol: 'État',
    ramCol: 'RAM (totale − base − engagée)',
    usableCol: 'Utilisable',
    vmsCol: 'Charge',
    neverSeen: 'jamais vu',
    freshChip: 'joignable',
    staleChip: 'injoignable',
    attestedChip: 'attesté éteint',
    ramFormula: 'totale − base − engagée',
    haTitle: 'Haute disponibilité',
    haSubtitle: 'Les VM avec le flag HA sont "toujours allumées" : TVirt les redémarre après chaque arrêt non demandé — même nœud avec backoff, un autre nœud quand le leur meurt (storage partagé seulement).',
    haNone: 'Aucune VM ne porte encore le flag HA — activez-le ici ou dans le détail de la VM.',
    haVmCol: 'Machine virtuelle',
    haStateCol: 'État',
    haRestartsCol: 'Redémarrages HA',
    haLastEventCol: 'Dernier événement',
    haToggleCol: 'HA',
    haCrashLoop: 'crash loop',
    haToggleError: 'La modification HA a été refusée',
    rules: {
      title: "Règles d'affinité",
      createTitle: 'Nouvelle règle de proximité',
      editTitle: 'Modifier la règle',
      nameHint: 'Minuscules, chiffres et tirets (étiquette DNS)',
      vms: 'Machines virtuelles',
      vmsHint: 'Au moins deux VM — la règle contraint où elles tournent les unes par rapport aux autres',
      type: 'Type',
      affinity: 'Affinité (ensemble)',
      antiAffinity: 'Anti-affinité (séparées)',
      typeAffinityHint: 'Les VM doivent tourner sur le MÊME nœud.',
      typeAntiAffinityHint: 'Les VM doivent tourner sur des nœuds DIFFÉRENTS — la paire HA classique.',
      mode: 'Mode',
      hard: 'hard',
      soft: 'soft',
      modeHardHint: "Les violations refusent l'opération (démarrage, migration, failover) avec une erreur parlante.",
      modeSoftHint: 'Préférence, jamais bloquante : un placement en violation procède avec un avertissement visible.',
      satisfied: 'Placement',
      satisfiedYes: 'respecté',
      satisfiedNo: 'violé',
      violations: 'Violations',
      noViolations: 'Aucune'
    },
    events: {
      title: 'Événements HA',
      subtitle: 'Le journal de la disponibilité — redémarrages, fencing, failovers et les sauts honnêtes',
      none: 'Encore rien.',
      when: 'Quand',
      kind: 'Événement',
      target: 'Objet',
      detail: 'Détail',
      kindRestarted: 'redémarrage HA',
      kindGaveUp: 'abandon (crash loop)',
      kindNodeAttested: 'nœud clôturé',
      kindFailedOver: 'failover',
      kindNoCandidate: 'aucun candidat',
      kindStorageLocalSkip: 'sauté (storage local)',
      kindZombieFenced: 'zombie terminé'
    }
  }
}
